import {
  Container,
  Typography,
  CircularProgress,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { useStudentTasks } from "../../api/getStudentTasks";
import CustomTable from "../../../../ui/components/Table";

const StudentTasks = ({ enrollmentId, courseId, studentId }) => {
  const { data, isLoading } = useStudentTasks({
    enrollmentId,
    courseId,
    studentId,
  });
  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography>Descrição</Typography>
          </TableCell>
          <TableCell>
            <Typography>Tipo</Typography>
          </TableCell>
          <TableCell>
            <Typography>Situação</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(data || []).map((task) => (
          <TableRow>
            <TableCell>
              <Typography>{task.descricao}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{task.tipo}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{task.SITUACAO}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </CustomTable>
  );
};

export { StudentTasks };
